import { Typography } from "@mui/material";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Box } from "@mui/material";
import { WhitePenciledLogo } from "../styles/HeaderStyles";

export default function PaymentSuccess() {
    return (
        <>
          <WhitePenciledLogo style={{ width: "150px", margin: "20px 15px", position: "absolute", top: "10px", left: "10px" }} />
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: '2rem', justifyContent: 'center', alignItems: 'center', height: '100dvh', margin: { xs: "0px 24px"}, textAlign: "center" }}>
            <Box>
              <CheckCircleIcon sx={{ fontSize: "5rem", color: "#00AC4F", background: "#D3FFE7", padding: "20px", borderRadius: "50%" }} />
            </Box>
            <Typography variant="h1" sx={{ fontSize: { xs: '2.25rem', sm: '2.5rem' }, color: '#FFF' }}>
              Payment successful!
            </Typography>
            <Typography variant="body1" sx={{ fontSize: { xs: '1rem' }, color: '#FFF', maxWidth: "600px" }}>
              Your payment has been successful! You will recieve a confirmation message regarding your appointment cancellation. You may now close this window.
            </Typography>
          </Box>
        </>
      )
}